import { ApiErrorCodes } from '@workspace/data-types';

export class EnumsNiceLabelUtils {
  static fileSize(size: number): string {
    const KB = 1024;
    const MB = KB * 1024;
    const GB = MB * 1024;

    if (size < MB) {
      return `${Math.round(size / KB)} KB`;
    } else if (size < GB) {
      return `${(size / MB).toFixed(1)} MB`;
    } else {
      return `${(size / GB).toFixed(2)} GB`;
    }
  }

  static erroCode(statusCode: number, errorCode: ApiErrorCodes): string {
    switch (statusCode) {
      case 429:
        return 'Trop de tentatives, veuillez réessayer dans quelques instants.';
    }
    switch (errorCode) {
      case ApiErrorCodes.OBJECT_NOT_FOUND:
        return "Le code est invalide ou n'a pas été trouvé.";
      case ApiErrorCodes.TOO_MANY_REQUESTS:
        return 'Trop de requêtes, veuillez réessayer dans quelques instants.';
      case ApiErrorCodes.OBJECT_EXPIRED:
        return 'Le code a expiré. Veuillez faire une autre demande';
      case ApiErrorCodes.OBJECT_USED:
        return 'Le code a déjà été utilisé !';
      case ApiErrorCodes.OBJECT_CANCELED:
        return "La code a été annulé, peut être à cause d'une nouvelle demande ? Veuillez saisir le code le plus récent.";
      default:
        return errorCode;
    }
  }
}
